function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    divided: {
      borderTop: "2px solid ".concat(colors.primaryLight)
    },
    icon: _defineProperty({
      display: 'none'
    }, mediaQueries.breakpointTablet, {
      display: 'inline-block',
      margin: '14px 15px 0 0'
    }),
    svgIcon: {
      fill: colors.white,
      width: '30px',
      height: '30px'
    }
  };
});